import React from 'react';
import { observer } from 'mobx-react';
import DeleteSubuserComponent from './Delete-subuser.component';
import useDeleteSubuser from './useDeleteSubuser';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, lang, handlers } = useDeleteSubuser(onClose);

    return (
        <>
            <DeleteSubuserComponent
                lang={lang.lang}
                loading={subusers.deleteLoading || subusers.loading}
                serverError={subusers.serverError}
                login={subusers.selectedSubuser}
                onConfirmClick={handlers.handleConfirmClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const DeleteSubuserContainer = observer(Container);

export default DeleteSubuserContainer;
